'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$Heading(lead, highlight, trail) {
  this.ie = null;
  this.id = null;
  this.ig = null;
  this.ie = lead;
  this.id = highlight;
  this.ig = trail;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$Heading as $c_Lio_intela_sites_digitalinternship_data_Segments$Heading };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$Heading.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$Heading;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$Heading() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$Heading as $h_Lio_intela_sites_digitalinternship_data_Segments$Heading };
$h_Lio_intela_sites_digitalinternship_data_Segments$Heading.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, (-2047840142), true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$Heading) && (((this.ie === x$0.ie) && (this.id === x$0.id)) && (this.ig === x$0.ig))));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 3;
});
$p.I = (function() {
  return "Heading";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.ie;
      break;
    }
    case 1: {
      return this.id;
      break;
    }
    case 2: {
      return this.ig;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Heading(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.by)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Heading as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$Heading };
var $d_Lio_intela_sites_digitalinternship_data_Segments$Heading = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$Heading, "io.intela.sites.digitalinternship.data.Segments$Heading", ({
  by: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$Heading as $d_Lio_intela_sites_digitalinternship_data_Segments$Heading };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Heading.js.map
